<template>
    <v-container id="general-report" fluid tag="section">
        <!-- <div class="text-sm-right mb-2"> -->
            <v-btn
                    v-if="checkAuthorization('account-report_download')"
                    class="primary mx-0 export-account-report-btn"
                    @click="clickExport"
            >
                <v-icon>mdi-download</v-icon>Download
            </v-btn>
        <!-- </div> -->
        <v-card class="my-0">
            <v-tabs
                v-model="tab"
            >
            <v-tabs-slider></v-tabs-slider>
                <v-row>
                    <v-tab
                        v-for="(item, key) in tabs"
                        :key="key"
                        class="col col-6"
                    >
                        {{item}}
                    </v-tab>
                </v-row>
                    <v-tab-item>
                        <account-report-table 
                            :accountData="accountData"
                        />
                    </v-tab-item>

                    <v-tab-item>
                        <account-report-class-table 
                            :accountClassData="accountClassData"
                        />
                    </v-tab-item>
            </v-tabs>
        </v-card>
    </v-container>
</template>

<script>
import AccountReportTable from "./components/AccountReportTable"
import AccountReportClassTable from "./components/AccountReportClassTable"
import moment from 'moment'
import RepositoryFactory from "@/repositories/RepositoryFactory"
import TokenService from "../../../helpers/token"

const ReportRepository = RepositoryFactory.get('report')

export default {
    components: { AccountReportTable, AccountReportClassTable },
    data() {
        return {
            filterForm: {
                month: moment().format('YYYY-MM')
            },
            accountData: [],
            accountClassData: [],
            tabs: ['Tổng quan', 'Theo khối'],
            tab: 0
        }
    },
    created() {
        this.getAccountReport()
        this.getAccountReportClass()
        // Bus.$on('account-report-search-filter', filterForm => {
        //     this.filterForm = filterForm
        //     this.getAccountReport()
        // })
    },
    methods: {
        async getAccountReport() {
            const loading = this.$loading.show()
            
            const res = await ReportRepository.accountReport({})
            if (res.success) {
                this.accountData = _.get(res, 'data', [])
            } else {
                this.accountData = []
            }
            loading.hide()
        },

        async exportExcel() {
            const loader = this.$loading.show();

            let user = await TokenService.getUser()
            ReportRepository.exportExcelAccountReport({username: user.username})

            loader.hide();

            this.$swal({
                title: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!'
            })
        },

        async getAccountReportClass() {
            const loading = this.$loading.show()
            
            const res = await ReportRepository.accountReportClass({})
            if (res.success) {
                this.accountClassData = _.get(res, 'data', [])
            } else {
                this.accountClassData = []
            }
            loading.hide()
        },

        async exportExcelClass() {
            const loader = this.$loading.show();

            let user = await TokenService.getUser()
            ReportRepository.exportExcelAccountReportClass({username: user.username})

            loader.hide();

            this.$swal({
                title: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!'
            })
        },

        async clickExport() {
            if (this.tab == 0) {
                await this.exportExcel()
            } else if (this.tab == 1) {
                await this.exportExcelClass()
            }
        }
    }
}
</script>

<style scoped>
.export-account-report-btn {
    position: absolute;
    z-index: 9999;
    right: 20px;
    top: 15px;
}
</style>